<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand icon-img-100" [routerLink] = "'/'">
            <img [src]="logo" alt="Logo" class="logo">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div [ngClass]="{'collapse navbar-collapse': true, 'show': !isCollapsed}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('home')">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('about')">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('team')">Team</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('services')">Services</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('works')">Works</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('testimonials')">Testimonials</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('blogs')">Blogs</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('contact')">Contact</a>
                </li>
            </ul>
            <div class="nav-button ms-auto xs-ml-0 xs-mt-20"><ul class="nav navbar-nav navbar-right"><li><button type="button" class="btn btn-primary btn-sm btn-square btn-animate remove-margin"><span>Purchase Now <i class="ion-android-arrow-forward"></i></span></button></li></ul></div>
        </div>
        
    </div>
</nav>